// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4759) return "static/chunks/4759.ae4b084dd70a13e0.js";
	if (chunkId === 6967) return "static/chunks/6967.b49a415a355ccf74.js";
	if (chunkId === 3384) return "static/chunks/3384.9be0253e70d2300d.js";
	if (chunkId === 1822) return "static/chunks/1822.1a1417fc5400292e.js";
	if (chunkId === 7359) return "static/chunks/7359.284a8a6f35c217bc.js";
	if (chunkId === 9428) return "static/chunks/9428.6494c2dae89fad7c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1545":"d33fd29609b97fcf","1867":"4d11ea3f16936cdd","1961":"76995f3beea3f217","5723":"574216c51ab8157d","5973":"d0695a3776e6e544","8280":"2eebf22cc58abc1e","8577":"9204f556c0213240","9418":"4cef63caff2399c9","9433":"209ecf3f55756222"}[chunkId] + ".js";
};